import memoryStorage, { testStorageSupport } from 'memory-web-storage';

var storage = testStorageSupport() ? window.localStorage : memoryStorage;

var index = {
	setItem: function setItem(key, data) {
		return new Promise(function (resolve) {
			return resolve(storage.setItem(key, data));
		});
	},
	getItem: function getItem(key) {
		return new Promise(function (resolve) {
			return resolve(storage.getItem(key));
		});
	},
	removeItem: function removeItem(key) {
		return new Promise(function (resolve) {
			return resolve(storage.removeItem(key));
		});
	}
};

export default index;
